(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/svs-socket/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/core/svs-socket/assets/javascripts/prescript.js');
"use strict";

svs = svs || {};
svs.core = svs.core || {};
svs.core.svsSocket = svs.core.svsSocket || {};
svs.core.svsSocket.get = svs.core.svsSocket.get || undefined;
svs.core.config = svs.core.config || {};
svs.core.config.data = svs.core.config.data || {};
svs.core.config.data.svsconfig = svs.core.config.data.svsconfig || {};
svs.core.config.data.svsconfig.svsFetchBaseUri = svs.core.config.data.svsconfig.svsFetchBaseUri || '';

 })(window);